// https://www.npmjs.com/package/vue-acl

// ALWAYS ROUTING TO 'notfound' BUG FIX: https://github.com/zeit/serve/issues/515
// 1. install 'serve' (npm install -g serve)
// 2. build (npm run build)
// 3. serve via serve with -s (Single-Page Application) flag (serve -s dist)
// (already made these changes (1 & 2) to 'serve' script in package.json)

import Vue from "vue";
import {AclInstaller, AclCreate, AclRule} from "vue-acl";
import router from "@/router";
import store from "@/store/store";
import api from '@/http/api';

Vue.use(AclInstaller);

/** all roles: 'super_admin', 'general_csr', 'product_manager', 'accounting', 'temp' */
let initialRole = "public";
let userInfo = JSON.parse(localStorage.getItem("activeUser"));
if (userInfo && userInfo.access_role) initialRole = userInfo.access_role;

export default new AclCreate({
  initial: initialRole,
  notfound: {
    path: "/pages/login",
    forwardQueryParams: true
  },
  router,
  acceptLocalRules: true,
  globalRules: {
    isAdmin: new AclRule("super_admin").or("accounting").generate(),
    isCsr: new AclRule("general_csr").or("temp").or("super_admin").or("accounting").generate(),
    isProductManager: new AclRule("product_manager").or("super_admin").or("accounting").generate(),
    isLoggedIn: new AclRule("general_csr").or("temp").or("super_admin").or("accounting").or("product_manager").generate(),
    isPublic: new AclRule("*").generate(),
  },
  middleware: async acl => {
    // async method executed in all route change event, to get user in your api and change permission

    // log the user out if the token is expired
    if (api.isTokenExpired(store.state.activeUserToken) && store.state.activeUser.access_role !== initialRole) {
      await store.dispatch('clearUserInfo');
    }

    let newRole = store.state.activeUser.access_role;

    if (newRole !== acl.get()) {
      acl.change(newRole);
    }
  }
});
